import { MoovVariableDTO } from "../DTO/moovVariableDTO";

export class MoovVariable{
    public id!: number;
    public name!: string;
    public value!: string;
    public customerId!: number; //if not set, then available to all customers. can only be created by super admin
    public added!: Date;
    public edited!: Date;
    public addedByUserId!: number;
    public editedByUserId!: number;

    

    public static mapFromDTO(param:MoovVariableDTO):MoovVariable{ 
        if (!param) throw new Error("parameter is null")
        let obj = new MoovVariable();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.value=param.value;
            obj.customerId = param.customerId;
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
            obj.addedByUserId = param.addedByUserId;
            obj.editedByUserId = param.editedByUserId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:MoovVariable):MoovVariableDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new MoovVariableDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.value=param.value;
            dto.customerId = param.customerId;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.edited = param.edited.toISOString();
            dto.addedByUserId = param.addedByUserId;
            dto.editedByUserId = param.editedByUserId;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }
}